import Api from '@/Api'

export default class ClientOnboardingApi extends Api {
  /** Gets client details based on the  token */
  getClientDetails = (params) => {
    return this.get(`/api/v1/public/groups/applications/${params.applicationId}/recipients/${params.recipientUUID}`)
  };

  /** Create/update new client details */
  createNewClient = (params = {}, payload = {}) => {
    return this.put(`/api/v1/public/groups/applications/${params.applicationId}/recipients/${params.recipientUUID}`, payload)
  };

  /** Retrieves Docusign URL to begin signing ceremony */
  getDocusignClosing= (params) => {
    return this.get(`/api/v1/public/groups/applications/${params.applicationId}/recipients/${params.recipientUUID}/closing`)
  };

  /** Gets Location details based on the zip code by using public util */
  getLocationDetailsFromZipCode = (options = {}) => {
    if (!options.zipCode) {
      throw new Error('No zip code provided')
    }
    return this.get(`/api/v1/public/zipcodes/${options.zipCode}`, options.params)
  };
}
